import { TranslationResource } from '@wrisk/web-app/src/infrastructure/internationalisation'

import de from './de'
import en from './en'

export const translations: TranslationResource = {
  en,
  de,
}
